// extracted by mini-css-extract-plugin
export const active = "RewardDetailsTabsDesktop__active__69yd1";
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const tab = "RewardDetailsTabsDesktop__tab__SWlSK";
export const tabs = "RewardDetailsTabsDesktop__tabs__heHlV";
export const textCenter = "RewardDetailsTabsDesktop__textCenter__FUnL+";